import {AddIcon} from '@modifi/ui'
import styled from 'styled-components'

export const StyledAddIcon = styled(AddIcon)`
  margin: 0 8px;
`
